export default function InfoIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.867" height="16.867" viewBox="0 0 16.867 16.867">
      <g id="Icon_ionic-ios-information-circle-outline" data-name="Icon ionic-ios-information-circle-outline" transform="translate(-3.375 -3.375)">
        <path id="Trazado_38" data-name="Trazado 38" d="M16.552,11.515a.836.836,0,1,1,.831.811A.812.812,0,0,1,16.552,11.515Zm.057,1.447h1.549v5.843H16.608Z" transform="translate(-5.578 -3.105)" fill="#232323"/>
        <path id="Trazado_39" data-name="Trazado 39" d="M11.808,4.51A7.3,7.3,0,1,1,6.647,6.647,7.25,7.25,0,0,1,11.808,4.51m0-1.135a8.433,8.433,0,1,0,8.433,8.433,8.432,8.432,0,0,0-8.433-8.433Z" fill="#232323"/>
      </g>
    </svg>
  );
}